import { PERSON_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const personApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getContificoPersonData: builder.mutation({
            query: ({ docId }) => ({
                url: `${PERSON_URL}`,
                method: 'GET',
                params: { identificacion: docId },
                timeout: 10000,
            }),
            keepUnusedDataFor: 5,
            providesTags: ['Person'],
        }),
        createContificoPersonClient: builder.mutation({
            query: (data) => ({
                url: `${PERSON_URL}`,
                method: 'POST',
                body: data,
                timeout: 10000,
            }),
            invalidatesTags: ['Person'],
        }),
    }),
});

export const { useGetContificoPersonDataMutation, useCreateContificoPersonClientMutation } =
    personApiSlice;
